module.exports = __webpack_public_path__ + "img/indesign.7b784165.svg";